import { isNil } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { QUAL_REVIEWS_MOBILE_WEB } from '../experimentsEnum';
import { inAbTest, getTestVariation } from '..';

const isInWebMobileExp = (version = null) => {
    const { abTests, isMobile } = getContext();

    if (!isMobile || !inAbTest(abTests, QUAL_REVIEWS_MOBILE_WEB)) {
        return false;
    }
    return isNil(version) || getTestVariation(abTests, QUAL_REVIEWS_MOBILE_WEB) === version;
};

export default isInWebMobileExp;
